import { fetchListingEpic } from "./epics"
import { combineEpics } from "redux-observable"

export const combinedEpics = combineEpics(
    fetchListingEpic,
)
export const InventoryStockDocumentDefinitionEpics = combinedEpics


// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/epics/index.ts